import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { maybeApplyCallback } from '@shared/utils/maybeApplyCallback';
import { StyledAvatarWithFallback } from '../../IdentityWidget.styles';
import { useGetEventPhotoByEventHandleQuery } from '@graphql/generated';
import { ReactComponent as IconCamera } from '@assets/icons/icon-camera-2.svg';

type EventPhotoProps = {
  handleOnAddPhotosClick: () => void;
  eventHandle: string;
  addPhotoText: string;
};

export const EventPhoto = ({ addPhotoText, eventHandle, handleOnAddPhotosClick }: EventPhotoProps) => {
  const { data, loading } = useGetEventPhotoByEventHandleQuery({
    variables: {
      website: eventHandle,
    },
    batchMode: 'fast',
  });
  const photoUrl = data?.eventByName?.photo?.url;
  return (
    <StyledAvatarWithFallback
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      size={[pxToRem(71), null, pxToRem(104)]}
      $avatarUrl={photoUrl}
      onClick={maybeApplyCallback(!photoUrl && !loading, handleOnAddPhotosClick)}
    >
      {!photoUrl && (
        <Flex
          cursor="pointer"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <IconCamera />
          <TextV2
            fontSize="12px"
            marginTop={1}
          >
            {addPhotoText}
          </TextV2>
        </Flex>
      )}
    </StyledAvatarWithFallback>
  );
};
